import React from "react";
import parse from "html-react-parser";
import Man from "../../../assets/blog/_0041.png";

export default function Content({ blog }) {
  return (
    <div className="mt-4 content position-relative text-white bg-secondary p-2 p-lg-3 p-md-3 p-sm-2 rounded-4 text-start">
      <span
        style={{
          width: "fit-content",
        }}
        className="badge bg-success d-flex gap-1 align-items-center"
      >
        <img
          src="https://img.icons8.com/?size=100&id=6Z5IUAh18Fuc&format=png&color=ffffff"
          alt="clock"
          style={{ width: "1rem" }}
        />
        {blog?.read_time} min{" "}
      </span>
      <div className="mt-2 blog-content"
        dangerouslySetInnerHTML={{ __html: blog?.description }}
      />
      <img
        src={Man}
        className="position-absolute d-none d-md-block"
        style={{
          width: 300,
          height: "auto",
          objectFit: "cover",
          top: 0,
          right: -220,
        }}
        alt="man"
      />
    </div>
  );
}
